import React, { Component } from 'react';
import { BrowserRouter as Router, Link } from 'react-router-dom'; // eslint-disable-line no-unused-vars
import Nav from './shared/nav';
import logo from './assets/img/logo.png';
import './assets/styles/App.css';


class Header extends Component {
  render() {
    return (
      <div className="app-header">
        <div className="app-header-container">
          <div className = "app-logo-container">
          <Link to="/">
            <img src={logo} className="app-logo" alt="eitx-logo" />
            </Link>
          </div>
          <Nav />
        </div>
      </div>
    );
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/Header.js